import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/bookingActions'
import { getParser } from '../../adapters'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchEasymsBookingCategories = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.B_EASYMS_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsCategories(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.b_fetchEasymsCategoriesSuccess(getParser(urls.easymsCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_fetchEasymsCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий EasyMS произошла ошибка'
            )
        )
}

/** @thunk **/
export const fetchEasymsBookingRates = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.B_EASYMS_RATES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsRates(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.b_fetchEasymsRatesSuccess(getParser(urls.easymsRates)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_fetchEasymsRatesFailure,
                'Что-то пошло не так!',
                'При получении тарифов EasyMS произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/bookingApi/bookingEasyms.js